export const heading1 = 'text-4xl font-bold'
export const heading3 = 'text-xl font-bold'